import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  Field,
  FieldArray,
  reduxForm,
  formValueSelector,
  change,
} from "redux-form";
import {
  renderInput,
  renderFilterSelect,
  RenderFileUpload,
  checkQtyIsValid,
  successToast,
} from "../utils/renderUtils";
import Loading from "../Loading";
import Translate, { translate } from "../dictionary/Translator";
import ui from "./dictionary/ui";
import { Button } from "react-bootstrap";
import ReactModal from "react-modal";
import DocumentTitle from "react-document-title";
import * as orderActions from "../../modules/order";
import * as cartActions from "../../modules/cart";
import * as utilsActions from "../../modules/utils";
import MdAddCircleOutline from "react-icons/lib/md/add-circle-outline";
import MdRemoveRedEye from "react-icons/lib/md/remove-red-eye";
import MdDelete from "react-icons/lib/io/ios-trash";
import MdCloudUpload from "react-icons/lib/md/cloud-upload";
import { getAlphaNumSkuToCompare } from "../utils/jsUtils";
import moment from "moment";
import cartImage from "../../static/images/Cart.png";
import { toast } from "react-toastify";
import "./ProductAvailability.css";
import EmailProvider from "../Help/EmailProvider";
import * as XLSX from "xlsx";

const selector = formValueSelector("inventoryForm");
const cartSelector = formValueSelector("cart");

const ProductAvailability = (props) => {
  const {
    clearPreOrder,
    buyer,
    addresses,
    language,
    contract,
    user,
    simulateOrder,
    contractType,
  } = props;
  useLayoutEffect(() => {
    clearPreOrder();
    return () => {
      clearPreOrder();
    };
  }, []);

  const handleInventoryCheck = (values) => {
    const listWithGrade = utilsActions.updateCartItemsWithGrade({
      items: [...values.itemList],
      shippingAddress: buyer.id,
    });
    let billToId = utilsActions.getDefaultAddress(
      addresses,
      buyer,
      utilsActions.billToAddressType,
    );
    let payerId = utilsActions.getDefaultAddress(
      addresses,
      buyer,
      utilsActions.payerAddressType,
    );
    let langId = translate({
      word: ui["LANG_ID"],
      language: language,
    });
    simulateOrder(
      listWithGrade,
      buyer,
      payerId,
      billToId,
      contract,
      user,
      langId,
    );
  };
  const isProEnglish =
    contractType === "professional" && language !== "fr_CA" ? true : false;
  return (
    <DocumentTitle
      title={`${translate({
        dictionary: ui,
        word: "TITLE",
        language,
      })} | Sony ExpressNet`}
    >
      <div className="main-container">
        <InventoryForm onSubmit={handleInventoryCheck} {...props} />
        <div className="notes-disclaimer">
          <ul className="tbd-disclaimer">
            <li>
              <Translate dictionary={ui} word="AVAILABILITY_NOTE" />
            </li>
            <li>
              {isProEnglish ? (
                <>
                  <Translate
                    dictionary={ui}
                    word="PRO_ENGLISH_AVAILABILITY_QUESTIONS"
                  />
                  <a
                    href="https://na.info.pro.sony/ETA_request.html"
                    target="_blank"
                    style={{
                      fontStyle: "italic",
                      color: "#2F6FA7",
                      textDecoration: "underline",
                    }}
                  >
                    <Translate dictionary={ui} word="ETA_PRO_FORM" />
                  </a>
                  .
                </>
              ) : (
                <>
                  <>
                    <Translate
                      dictionary={ui}
                      word="PRODUCT_AVAILABLE_QUESTION"
                    />
                    <EmailProvider />.
                  </>
                </>
              )}
            </li>
          </ul>
        </div>
      </div>
    </DocumentTitle>
  );
};

// *********** popup componet to upload list of materials to check ***********
const PopUpUploadDialogBox = (props) => {
  const {
    InvItems,
    isFileUploadPopupOpen,
    setIsFileUploadPopupOpen,
    language,
    priceBook,
    change,
    clearPreOrder,
  } = props;
  const initialStatus = {
    errors: undefined,
    listUpdates: undefined,
    isEmpty: false,
    contentError: false,
    fileTypeError: false,
    limitExceeded: false,
    limitExceededList: [],
    multipleQtyList: [],
  };
  const [uploadStatus, setUploadStatus] = useState(initialStatus);
  const handleStatusUpdate = (updatedProp) => {
    setUploadStatus((prev) => ({ ...prev, ...updatedProp }));
  };
  const handleFiles = (event) => {
    var files = event.target.files;
    handleStatusUpdate(initialStatus);
    if (files && files.length > 0) {
      var file = files[0];
      if (
        file.type !== "text/csv" ||
        !(file.name && file.name.toLowerCase().endsWith(".csv"))
      ) {
        handleStatusUpdate({ fileTypeError: true });
        return;
      } else {
        utilsActions.parseCSV(file, (parsedData) => {
          if (!parsedData || !parsedData.data || parsedData.data.length === 0) {
            handleStatusUpdate({ isEmpty: true });
            return;
          }
          var TemplateHeaders = Object.keys(parsedData.data[0]);

          if (
            !TemplateHeaders ||
            TemplateHeaders.length === 0 ||
            TemplateHeaders[0].toUpperCase() !== "MODEL" ||
            //A stock and B stock quantity fields added in Template
            TemplateHeaders[1].toUpperCase() !== "A STOCK QUANTITY" ||
            TemplateHeaders[2].toUpperCase() !== "B STOCK QUANTITY"
          ) {
            handleStatusUpdate({ contentError: true });
            return;
          }

          let errorArray = [];
          let listUpdates = [];

          parsedData.data.forEach(function (Item) {
            var sku = Item[TemplateHeaders[0]];
            var AQty = Item[TemplateHeaders[1]];
            var BQty = Item[TemplateHeaders[2]];
            var parsedItem =
              sku && sku.trim() !== ""
                ? getAlphaNumSkuToCompare(sku).toUpperCase()
                : undefined;

            var priceBookItem = priceBook.find(
              (pbItem) =>
                pbItem.sku.trim().toUpperCase() === parsedItem ||
                pbItem.originalSku.trim().toUpperCase() === parsedItem,
            );
            var hasAStockPrice = priceBookItem && priceBookItem.has_Astock;
            var hasBStockPrice = priceBookItem && priceBookItem.has_Bstock;
            if (priceBookItem && hasAStockPrice && hasBStockPrice) {
              if (checkQtyIsValid(AQty) && checkQtyIsValid(BQty)) {
                setUploadStatus((prev) => ({
                  ...prev,
                  multipleQtyList: [...prev.multipleQtyList, priceBookItem.sku],
                }));
                listUpdates.push({
                  sku: priceBookItem.sku,
                  AStockQty: AQty,
                });
                listUpdates.push({
                  sku: priceBookItem.sku,
                  BStockQty: BQty,
                });
              } else if (checkQtyIsValid(AQty) && !checkQtyIsValid(BQty)) {
                listUpdates.push({
                  sku: priceBookItem.sku,
                  AStockQty: AQty,
                });
                if (BQty) {
                  errorArray.push({
                    MODEL: sku,
                    BStockQty: BQty,
                  });
                }
              } else if (!checkQtyIsValid(AQty) && checkQtyIsValid(BQty)) {
                listUpdates.push({
                  sku: priceBookItem.sku,
                  BStockQty: BQty,
                });
                if (AQty) {
                  errorArray.push({
                    MODEL: sku,
                    AStockQty: AQty,
                  });
                }
              } else {
                errorArray.push({
                  MODEL: sku,
                  AStockQty: AQty,
                  BStockQty: BQty,
                });
              }
            } else if (priceBookItem && !hasBStockPrice && hasAStockPrice) {
              if (checkQtyIsValid(AQty)) {
                if (BQty) {
                  errorArray.push({
                    MODEL: sku,
                    AStockQty: "",
                    BStockQty: BQty,
                  });
                }
                listUpdates.push({
                  sku: priceBookItem.sku,
                  AStockQty: AQty,
                });
              } else {
                errorArray.push({
                  MODEL: sku,
                  AStockQty: AQty,
                  BStockQty: BQty,
                });
              }
            } else if (priceBookItem && hasBStockPrice && !hasAStockPrice) {
              if (checkQtyIsValid(BQty)) {
                if (AQty) {
                  errorArray.push({
                    MODEL: sku,
                    AStockQty: AQty,
                    BStockQty: "",
                  });
                }
                listUpdates.push({
                  sku: priceBookItem.sku,
                  BStockQty: BQty,
                });
              } else {
                errorArray.push({
                  MODEL: sku,
                  AStockQty: AQty,
                  BStockQty: BQty,
                });
              }
            } else {
              errorArray.push({ MODEL: sku, AStockQty: AQty, BStockQty: BQty });
            }
          });
          const newInvItems = InvItems
            ? InvItems.filter(
                (item) => item.sku || item.AStockQty || item.BStockQty,
              )
            : [];
          clearPreOrder();
          change("itemList", newInvItems);

          const total = InvItems.length + listUpdates.length;
          if (utilsActions.validateCartMaxLimit(total)) {
            handleStatusUpdate({ limitExceeded: true });
            return;
          }
          handleStatusUpdate({ errors: errorArray, listUpdates });
        });
      }
    }
    event.target.value = null;
  };
  const handleUpdate = (listUpdates) => {
    const filteredInvItems = InvItems
      ? InvItems.filter((item) => item.sku || item.AStockQty || item.BStockQty)
      : [];
    change("itemList", [...filteredInvItems, ...listUpdates]);
    setIsFileUploadPopupOpen(false);
  };
  return (
    <ReactModal
      ariaHideApp={false}
      isOpen={isFileUploadPopupOpen}
      onRequestClose={() => setIsFileUploadPopupOpen(false)}
      className="POUpload__Modal"
      overlayClassName="POUpload__Overlay"
      style={{
        overlay: {
          zIndex: 2, // ensures overlay is above other elements
        },
        content: {
          zIndex: 3, // ensures modal content is above overlay
        },
      }}
    >
      <div>
        <h1 style={{ fontSize: "2.4rem", fontWeight: "600" }}>
          <Translate dictionary={ui} word="INVENTORY_LIST_UPLOAD" />
        </h1>
        <hr />
        <button
          onClick={() => setIsFileUploadPopupOpen(false)}
          className="close-icon"
          aria-label="close the upload po"
        >
          X
        </button>
        <p>
          <Translate dictionary={ui} word="UPLOAD_MSG1" />
          <a
            href={"/assets/docs/PO_TEMPLATE.csv"}
            download={"Inventory_Check_Template.csv"}
            style={{ fontWeight: "700", color: "#2F6FA7" }}
            aria-describedby="sample-desc"
          >
            <Translate dictionary={ui} word="UPLOAD_MSG2" />
          </a>
          <p className="offscreen" id="sample-desc">
            download sample file
          </p>
          <Translate dictionary={ui} word="UPLOAD_MSG3" />
        </p>
        <span
          style={{ wordWrap: "break-word", whiteSpace: "pre-wrap" }}
          className="disclaimer"
        >
          <Translate dictionary={ui} word="LIMIT_ERR" />
        </span>

        <RenderFileUpload
          handleFiles={handleFiles}
          fileTypes={[".csv"]}
          label={translate({
            word: ui["UPLOAD_BTN_LABEL"],
            language,
          })}
        />
      </div>

      {uploadStatus.multipleQtyList.length > 0 && (
        <h3
          style={{
            fontSize: "1.5rem",
            fontWeight: "600",
            color: "blue",
          }}
        >
          <Translate
            dictionary={ui}
            word="UPLOAD_INFO_QUANTITY_TYPE_SEPARATE_ITEMS"
          />{" "}
          {uploadStatus.multipleQtyList.join(", ")}
        </h3>
      )}

      {uploadStatus.contentError && (
        <>
          <h2
            style={{
              fontSize: "1.7rem",
              fontWeight: "600",
              color: "red",
            }}
          >
            <Translate dictionary={ui} word="UPLOAD_FAILED_INVALID_STRUCTURE" />
          </h2>
        </>
      )}
      {uploadStatus.isEmpty && (
        <>
          <h2
            style={{
              fontSize: "1.7rem",
              fontWeight: "600",
              color: "red",
            }}
          >
            <Translate dictionary={ui} word="UPLOAD_FAILED_EMPTY_FILE" />
          </h2>
        </>
      )}
      {uploadStatus.fileTypeError && (
        <>
          <h2
            style={{
              fontSize: "1.7rem",
              fontWeight: "600",
              color: "red",
            }}
          >
            <Translate
              dictionary={ui}
              word="UPLOAD_FAILED_INVALID_FILE_FORMAT"
            />
          </h2>
        </>
      )}
      {uploadStatus.limitExceeded && (
        <>
          <h2
            style={{
              fontSize: "1.7rem",
              fontWeight: "600",
              color: "red",
            }}
          >
            <Translate
              dictionary={ui}
              word="UPLOAD_FAILED_COMBINED_ITEM_LIMIT_EXCEEDED"
            />
          </h2>
        </>
      )}

      {/* on successful file read with/without error */}
      {(uploadStatus.errors || uploadStatus.listUpdates) && (
        <div>
          {uploadStatus.listUpdates && (
            <h2
              style={{
                fontSize: "1.7rem",
                fontWeight: "600",
                color:
                  uploadStatus.listUpdates.length === 0 ? "red" : "inherit",
              }}
            >
              {uploadStatus.listUpdates.length}
              <Translate dictionary={ui} word="VALID_MODELS" />
            </h2>
          )}
          {uploadStatus.listUpdates && <hr />}
          {uploadStatus.errors && uploadStatus.errors.length > 0 && (
            <div>
              <h3 style={{ fontSize: "1.5rem", fontWeight: "600" }}>
                <Translate dictionary={ui} word="UPLOAD_FAILED_MODELS" />
              </h3>
              <div className="overflow-wrapper-two-direction">
                <table className="table">
                  <thead>
                    <tr>
                      <th>
                        <Translate dictionary={ui} word="UPLOAD_NUMBER" />
                      </th>
                      <th>
                        <Translate dictionary={ui} word="PRODUCT_SKU" />
                      </th>
                      {/* PO error column for A stock quantity for which cart upload failed */}
                      <th>
                        <Translate dictionary={ui} word="A_QUANTITY" />
                      </th>
                      {/* PO error columns for B stock quantity for which cart upload failed */}
                      <th>
                        <Translate dictionary={ui} word="B_QUANTITY" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {uploadStatus.errors.map((error, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td> {error.MODEL}</td>
                        <td> {error.AStockQty}</td>
                        <td> {error.BStockQty}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {uploadStatus.listUpdates && (
            <div className="inline-buttons">
              <Button
                bsStyle="primary"
                className="btn-margin button"
                style={{ marginTop: "10px" }}
                id="Upload"
                onClick={() => handleUpdate(uploadStatus.listUpdates)}
                disabled={uploadStatus.listUpdates.length === 0}
              >
                <Translate dictionary={ui} word="UPLOAD" />
              </Button>
              <Button
                bsStyle="primary"
                className="btn-margin button"
                style={{ marginTop: "10px" }}
                id="Cancel"
                onClick={() => setIsFileUploadPopupOpen(false)}
              >
                <Translate dictionary={ui} word="CANCEL" />
              </Button>
            </div>
          )}
        </div>
      )}
    </ReactModal>
  );
};

// *********** Componet for table line items ***********
let InventoryItem = (props) => {
  const {
    item,
    index,
    skuValue,
    AStockQty,
    BStockQty,
    handleSkuChange,
    sku_options,
    priceBook,
    language,
    preorder,
    toggleSelection,
    selectedItems,
    containerRef,
  } = props;
  const sku_item =
    skuValue &&
    skuValue.length &&
    priceBook.find((x) => x.sku === skuValue || x.originalSku === skuValue);
  const desc = sku_item && sku_item.short_desc[language];
  const [result, setResult] = useState({});
  useEffect(() => {
    if (preorder !== undefined) {
      const item = preorder?.items[index];
      const utcDate = new Date().toISOString().split("T")[0];
      if (skuValue === item?.requestedSKU) {
        let plant_category_check =
          ["ZSDD", "ZCTO"].includes(item?.item_category) ||
          ["US04", "US10"].includes(item?.item_plant);
        let scheduleLineMapping =
          item?.nonZeroConfQtySchLines &&
          item?.nonZeroConfQtySchLines.length > 0
            ? item?.nonZeroConfQtySchLines
            : item?.schedule;

        let avlQty = 0,
          avlDate = "",
          madeToOrderQty = 0,
          madeToOrderDate = "";

        scheduleLineMapping.forEach((lineItem) => {
          if (lineItem?.materialAvailableDate === utcDate) {
            avlQty = avlQty + lineItem?.confirmedQuantity;
            avlDate = lineItem?.shippingDate;
          } else {
            madeToOrderQty = madeToOrderQty + lineItem?.confirmedQuantity;
            madeToOrderDate = lineItem?.shippingDate;
          }
        });

        setResult(() => ({
          availableQty: avlQty,
          availableEstimatedShippingDate:
            avlQty !== 0 && !plant_category_check && avlDate
              ? moment(avlDate).format("MM/DD/YYYY")
              : avlQty === 0 && madeToOrderQty === 0
                ? "TBD"
                : "-",
          tobeAvailableQty: madeToOrderQty,
          tobeAvailableEstimatedShippingDate:
            madeToOrderQty !== 0 && !plant_category_check && madeToOrderDate
              ? moment(madeToOrderDate).format("MM/DD/YYYY")
              : madeToOrderQty === 0 && avlQty === 0
                ? "TBD"
                : "-",
        }));
      }
    } else {
      setResult({});
    }
  }, [preorder]);
  const isChecked = selectedItems.has(index);

  // Auto-Scroll to display complete select options.
  const rowRef = useRef(null);
  const handleVirtualizedSelectOptionOpen = () => {
    // wait for dropdown to render
    setTimeout(() => {
      const container = containerRef.current;
      const row = rowRef.current;

      if (!container || !row) return;

      const containerRect = container.getBoundingClientRect();
      const rowRect = row.getBoundingClientRect();

      const dropdown = document.querySelector(".Select-menu-outer");
      const dropdownHeight = dropdown?.offsetHeight || 200;

      const overflow = rowRect.bottom + dropdownHeight - containerRect.bottom;

      if (overflow > 0) {
        container.scrollTo({
          top: container.scrollTop + overflow,
          behavior: "smooth",
        });
      }
    }, 0);
  };

  return (
    <>
      <tr ref={rowRef}>
        <td>
          <input
            type="checkbox"
            checked={isChecked}
            onChange={() => toggleSelection(index)}
          />
        </td>
        <td>
          <Field
            id={`${item}.sku`}
            name={`${item}.sku`}
            component={renderFilterSelect}
            onChange={() => {
              setResult({});
              handleSkuChange(item);
            }}
            placeholder={<Translate dictionary={ui} word="CART_SKU_SELECT" />}
            filterOption={(option, filter) => {
              return (
                option.item.sku.indexOf(filter.toUpperCase()) >= 0 ||
                option.item.originalSku.indexOf(filter.toUpperCase()) >= 0
              );
            }}
            options={sku_options}
            label="SKU"
            onOpen={handleVirtualizedSelectOptionOpen}
          />
        </td>
        <td>
          <Field
            id={`${item}.AStockQty`}
            wrap={false}
            name={`${item}.AStockQty`}
            label="AStockQuantity"
            type="text"
            maxLength={9}
            component={renderInput}
            disabled={
              !sku_item || !(sku_item && sku_item.has_Astock) || BStockQty
                ? true
                : false
            }
            style={{ height: "35px", width: "50px" }}
          />
        </td>
        <td>
          <Field
            id={`${item}.BStockQty`}
            wrap={false}
            name={`${item}.BStockQty`}
            label="BStockQuantity"
            type="text"
            maxLength={9}
            component={renderInput}
            disabled={
              !sku_item || !(sku_item && sku_item.has_Bstock) || AStockQty
                ? true
                : false
            }
            style={{ height: "35px", width: "50px" }}
          />
        </td>
        <td arial-label="description">{desc}</td>
        <td arial-label="available-qty">{result?.availableQty}</td>
        <td arial-label="avl-delivery-dt">
          {result?.availableEstimatedShippingDate}
        </td>
        <td arial-label="to-be-mode-qty">{result?.tobeAvailableQty}</td>
        <td arial-label="to-be-qty-delivery-dt">
          {result?.tobeAvailableEstimatedShippingDate}
        </td>
      </tr>
    </>
  );
};

InventoryItem = connect(
  (state, props) => ({
    skuValue: selector(state, `${props.item}.sku`),
    AStockQty: selector(state, `${props.item}.AStockQty`),
    BStockQty: selector(state, `${props.item}.BStockQty`),
    sku_options: state.account.priceBook.map((item, index) => ({
      value: item.sku,
      label: item.sku,
      item,
    })),
    priceBook: state.account.priceBook,
    preorder: state.order.preOrder,
  }),
  (dispatch) => ({
    // Reset AStockQty and BStockQty fields on change of SKU
    handleSkuChange: (item) => {
      dispatch(change("inventoryForm", `${item}.AStockQty`, ""));
      dispatch(change("inventoryForm", `${item}.BStockQty`, ""));
    },
  }),
)(InventoryItem);

// *********** Field array componet  ***********
const RenderInventoryItems = (props) => {
  const {
    language,
    fields,
    setIsFileUploadPopupOpen,
    isFetching,
    cartItems,
    updateCart,
    clearPreOrder,
    preorder,
  } = props;
  const [addLineItemQty, setAddLineItemQty] = useState(1);
  // TODO: gracefully display error.
  const [error, setError] = useState({ error: false, msg: "" });
  const [selectedItems, setSelectedItems] = useState(new Set());
  const allSelected = fields.length > 0 && selectedItems.size === fields.length;
  const toggleSelection = (id) => {
    setSelectedItems((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(id)) newSet.delete(id);
      else newSet.add(id);
      return newSet;
    });
  };
  const isCartFull = selectedItems.size + cartItems?.length > 50;
  const handleAddToCart = (e) => {
    e.preventDefault();
    try {
      if (!isCartFull) {
        const itemList = fields.getAll();
        const newCart = [];
        selectedItems.forEach((value) => {
          const item = itemList[value];
          if (item.sku && (item.AStockQty || item.BStockQty)) {
            newCart.push(item);
          }
        });

        if (newCart.length > 0) {
          let cartArray = cartItems;
          cartArray = cartArray ? cartArray.concat(newCart) : newCart;
          updateCart(cartArray);
          successToast(
            translate({
              word: ui["CART_UPDATE_NOTIFICATION_SUCCESS"],
              language,
            }),
          );
          setSelectedItems(new Set());
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDownload = (e) => {
    e.preventDefault();
    const headers = [
      "SKU",
      "A_STOCK_QUANTITY",
      "B_STOCK_QUANTITY",
      "DESCRIPTION",
      "CURRENTLY_AVAILABILITY_QUANTITY",
      "CURRENTLY_AVAILABILITY_ESD",
      "ESTIMATED_AVAILABILITY_QUANTITY",
      "ESTIMATED_AVAILABILITY_ESD",
    ].map((e) => translate({ word: ui[e], language }));
    const table = document.getElementById("PA-table");
    const rows = Array.from(table.querySelectorAll("tbody tr"));

    const bodyData = rows.map((row) => {
      const cells = Array.from(row.querySelectorAll("td"));
      cells.shift();
      const obj = {};
      cells.forEach((cell, i) => {
        const input = cell.querySelector("input");
        // const select = cell.querySelector("select");
        // const selectLabel = cell.querySelector(
        //   ".Select-value-label, .Select__single-value",
        // );
        const optionSpan = cell.querySelector("span[role='option']");

        if (input) {
          // Try value property first
          let val = input.value && input.value.trim();
          // If empty, check the attribute
          if (!val && optionSpan) {
            val = optionSpan.innerText.trim();
          }
          obj[headers[i]] = val;
        } else {
          obj[headers[i]] = cell.innerText.trim(); // fallback to text
        }
      });
      return obj;
    });

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(bodyData, { header: headers });
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "ProductAvailability.csv");
  };

  const handleAddQtyChange = (e) => {
    let value = e.target.value;

    // allow empty while typing
    if (value === "") {
      setAddLineItemQty("");
      return;
    }

    let num = Number(value);

    if (isNaN(num)) {
      setAddLineItemQty(1);
      return;
    }

    if (num < 1) {
      setAddLineItemQty(1);
      return;
    }

    if (num > 50) {
      setAddLineItemQty(50);
      return;
    }

    // valid input
    setAddLineItemQty(num);
    setError({ error: false, msg: "" });
  };

  // Add initial lineItem when the form is empty.
  useEffect(() => {
    if (fields.length === 0) {
      fields.push({});
    }
  }, []);

  // Auto-Scroll to display complete select options.
  const containerRef = useRef(null);

  return (
    <>
      <div id="formMainContainer">
        <section className="btnSection">
          <div className="btnContainer">
            <div className="btnSubContainer">
              <input
                type="number"
                name="itemsqty"
                min={1}
                max={50}
                value={addLineItemQty}
                onChange={handleAddQtyChange}
                style={{ height: "35px", width: "50px", textAlign: "center" }}
                aria-label={ui["NUMBER_OF_LINES"][language]}
              />
              <Button
                bsStyle="primary"
                className="btn-margin button"
                disabled={
                  fields.length >= 50 || fields.length + addLineItemQty > 50
                }
                onClick={() => {
                  clearPreOrder();
                  setError({ error: false, msg: "" });
                  const totalCount =
                    parseInt(addLineItemQty, 10) + fields.length;
                  //validate the limit of 50 rows in cart
                  if (utilsActions.validateCartMaxLimit(totalCount)) {
                    setError({
                      error: true,
                      msg: "TOTAL_QUANTITY_LIMIT",
                    });
                  } else {
                    for (let i = 0; i < parseInt(addLineItemQty, 10); i++) {
                      fields.push({});
                    }
                  }
                  setAddLineItemQty(1);
                }}
              >
                <MdAddCircleOutline
                  className="button__icon"
                  role="img"
                  aria-label="Click to add items"
                />
                <Translate dictionary={ui} word="ADD_ITEM" />
              </Button>
              <Button
                bsStyle="primary"
                className="btn-margin button"
                onClick={() => setIsFileUploadPopupOpen(true)}
              >
                <MdCloudUpload
                  className="button__icon"
                  role="img"
                  aria-label="Click to upload PO file"
                />
                <Translate dictionary={ui} word="UPLOAD_LIST" />
              </Button>

              <Button
                bsStyle="primary"
                className="btn-margin button"
                style={{
                  cursor: fields.length === 0 ? "not-allowed" : "pointer",
                }}
                disabled={fields.length === 0}
                onClick={() => {
                  if (allSelected || selectedItems.size === 0) {
                    fields.removeAll();
                  } else if (selectedItems.size > 0) {
                    [...selectedItems]
                      .sort((a, b) => b - a)
                      .forEach((index) => fields.remove(index));
                  }
                  setSelectedItems(new Set());
                }}
              >
                <MdDelete
                  className="button__icon"
                  role="img"
                  aria-label="Click to clear Inventory form"
                />
                <Translate dictionary={ui} word="CLEAR" />
              </Button>

              <Button
                bsStyle="primary"
                id="topaddtocart"
                onClick={handleAddToCart}
                style={{ float: "right" }}
                disabled={
                  isCartFull || selectedItems.size === 0 || fields.length === 0
                }
                aria-describedby="addToCartInstr"
              >
                <img bb={40} height={25} src={cartImage} alt="Cart" />{" "}
                <Translate dictionary={ui} word="BTN_ADD_CART" />
              </Button>

              <Button
                bsStyle="primary"
                className="btn-margin button"
                onClick={handleDownload}
                style={{
                  float: "right",
                  cursor: preorder === undefined ? "not-allowed" : "pointer",
                }}
                disabled={preorder === undefined}
                aria-describedby="download"
              >
                <Translate
                  dictionary={ui}
                  word="PRODUCT_AVAILABILITY_DOWNLOAD"
                />
              </Button>
            </div>

            <div className="btnSubContainer">
              <Button
                id="CheckAvailability"
                bsStyle="primary"
                className="button btn-small-screen"
                type="submit"
                disabled={isFetching || fields.length === 0}
              >
                <MdRemoveRedEye
                  className="button__icon"
                  role="img"
                  aria-label="Preview Order"
                />
                <Translate dictionary={ui} word="CHECK_AVAILABILITY" />
              </Button>
            </div>
          </div>
          <span
            style={{
              color:
                fields.length + Number(addLineItemQty || 0) > 50
                  ? "#d32f2f"
                  : "#2F6FA7",
              fontSize: "1.3rem",
              fontWeight: 700,
              transition: "color 0.3s ease",
              padding: "7px 10px",
            }}
          >
            <Translate dictionary={ui} word={"LIMIT_DISCLAIMER"} />
          </span>
          {error.error && (
            <span className="amberAlert">
              <Translate dictionary={ui} word={error.msg} />
            </span>
          )}
        </section>
        <section id="tblContainer" ref={containerRef}>
          <table className="styled-table" id="PA-table">
            <thead>
              <tr className="main-header">
                <th width="5%">{fields.length}</th>
                <th rowSpan={2} width="15%">
                  <Translate dictionary={ui} word="SKU" />
                </th>
                <th rowSpan={2} width="7%">
                  <Translate dictionary={ui} word="A_STOCK_QUANTITY" />
                </th>
                <th rowSpan={2} width="7%">
                  <Translate dictionary={ui} word="B_STOCK_QUANTITY" />
                </th>
                <th rowSpan={2} width="20%">
                  <Translate dictionary={ui} word="DESCRIPTION" />
                </th>
                <th colSpan={2} width="23%">
                  <Translate dictionary={ui} word="CURRENT_AVAILABILITY" />
                </th>
                <th colSpan={2} width="23%">
                  <Translate dictionary={ui} word="ESTIMATED_AVAILABILITY" />
                </th>
              </tr>
              <tr className="sub-header">
                <th>
                  <input
                    type="checkbox"
                    checked={allSelected}
                    disabled={fields?.length <= 0}
                    onChange={() => {
                      setSelectedItems((prev) => {
                        const allCount = fields?.length || 0;
                        const newSet = new Set();
                        if (prev.size !== allCount) {
                          // Select all
                          fields.forEach((_, index) => newSet.add(index));
                        }
                        return newSet;
                      });
                    }}
                    title="Select All"
                  />
                </th>
                <th>
                  <Translate dictionary={ui} word="QUANTITY" />
                </th>
                <th>
                  <Translate dictionary={ui} word="ITEM_ESD" />
                </th>
                <th>
                  <Translate dictionary={ui} word="QUANTITY" />
                </th>
                <th>
                  <Translate dictionary={ui} word="ITEM_ESD" />
                </th>
              </tr>
            </thead>
            <tbody>
              {fields.map((item, index) => (
                <InventoryItem
                  item={item}
                  index={index}
                  key={index}
                  language={language}
                  toggleSelection={toggleSelection}
                  selectedItems={selectedItems}
                  containerRef={containerRef}
                />
              ))}
            </tbody>
          </table>
        </section>
      </div>
    </>
  );
};

// *********** Define ReduxForm ***********
let InventoryForm = (props) => {
  const {
    handleSubmit,
    language,
    isFetching,
    change,
    cartItems,
    updateCart,
    clearPreOrder,
    preorder,
  } = props;
  const [isFileUploadPopupOpen, setIsFileUploadPopupOpen] = useState(false);
  return (
    <form
      onSubmit={handleSubmit}
      onKeyPress={(e) => {
        if (e.key === "Enter") e.preventDefault();
      }}
    >
      <FieldArray
        name="itemList"
        component={RenderInventoryItems}
        setIsFileUploadPopupOpen={setIsFileUploadPopupOpen}
        isFetching={isFetching}
        language={language}
        cartItems={cartItems}
        updateCart={updateCart}
        clearPreOrder={clearPreOrder}
        preorder={preorder}
      />
      {isFileUploadPopupOpen && (
        <PopUpUploadDialogBox
          isFileUploadPopupOpen={isFileUploadPopupOpen}
          setIsFileUploadPopupOpen={setIsFileUploadPopupOpen}
          change={change}
          clearPreOrder={clearPreOrder}
          {...props}
        />
      )}
      {isFetching && <Loading />}
    </form>
  );
};

const validateForm = (values, props) => {
  const { priceBook, preorder, clearPreOrder } = props;
  if (preorder !== undefined) {
    clearPreOrder();
  }
  const errors = {};
  const itemsErrors = [];
  if (values.itemList?.length > 0) {
    values.itemList.forEach((item, itemIndex) => {
      const sku_item = priceBook.find((x) => x.sku === item.sku);
      const itemErrors = {};
      if (!item?.sku) {
        itemErrors.sku = <Translate dictionary={ui} word="SKU_REQUIRED" />;
        itemsErrors[itemIndex] = itemErrors;
      }
      if (!item?.AStockQty && !item?.BStockQty) {
        if (sku_item?.has_Astock && sku_item?.has_Bstock) {
          itemErrors.AStockQty = (
            <Translate dictionary={ui} word="INVALID_QTY" />
          );
          itemErrors.BStockQty = (
            <Translate dictionary={ui} word="INVALID_QTY" />
          );
        } else if (sku_item?.has_Astock) {
          itemErrors.AStockQty = (
            <Translate dictionary={ui} word="INVALID_QTY" />
          );
        } else if (sku_item?.has_Bstock) {
          itemErrors.BStockQty = (
            <Translate dictionary={ui} word="INVALID_QTY" />
          );
        }
        itemsErrors[itemIndex] = itemErrors;
      }
    });
  }
  if (itemsErrors.length) {
    errors.itemList = itemsErrors;
  }
  return errors;
};

InventoryForm = reduxForm({
  form: "inventoryForm",
  validate: validateForm,
  destroyOnUnmount: false,
})(InventoryForm);

// *********** Connecting states and dispatch for main component ***********
const mapDispatchToProps = (dispatch) => {
  return {
    simulateOrder: (cart, buyer, payerId, billToId, contract, user, language) =>
      dispatch(
        orderActions.simulateOrder(
          cart,
          buyer,
          payerId,
          billToId,
          contract,
          user,
          language,
        ),
      ),
    clearPreOrder: () =>
      dispatch({
        type: "SIMULATE_ORDER_SUCCESS",
        data: { preOrder: undefined },
      }),
    updateCart: (items) => dispatch(cartActions.updateCart(items)),
  };
};

const mapStateToProps = (state, props) => {
  return {
    buyer: state.account.buyer,
    contract: state.account.contract,
    user: state.account.user,
    addresses: state.account.addresses,
    language: state.language,
    InvItems: selector(state, "itemList"),
    cartItems: cartSelector(state, "items"),
    isFetching: state.common.isFetching,
    priceBook: state.account.priceBook,
    contractType: state.account.contract_type,
    preorder: state.order.preOrder,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductAvailability),
);
